jQuery(function () {
  var selectSelector = 'select[data-behaviour~="copy-on-change"], sp-select[data-behaviour~="copy-on-change"]';

  // BEHAVIOUR
  jQuery(document).on("change", selectSelector, copySelectText);

  // Copies the selected option's text into the field named by `data-copy-target`. A blank selection,
  // such as the prompt row, copies nothing.
  function copySelectText() {
    var selected = selectedOption(this);

    if (selected && selected.value !== "" && selected.value !== null && selected.value !== undefined) {
      jQuery(this.dataset.copyTarget).val(selected.text);
    }
  }

  // Returns the selected option as `{ text, value }`, from a native select's options or an sp-select's items,
  // or `null` when nothing is selected.
  function selectedOption(select) {
    if (select.tagName === "SP-SELECT") {
      var item = (select.items || []).find(function (candidate) {
        return String(candidate.value) === String(select.value);
      });

      return item ? { text: item.title, value: item.value } : null;
    }

    var option = select.options[select.selectedIndex];

    return option ? { text: option.text, value: option.value } : null;
  }
});
